import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormStatus, LoadBankType, LocationType } from '../models/Enums';
import { ListItem } from '../models/ListItem';
import { MOBILE_BREAKPOINT } from '../constants/app.constants';
import { Dispatch } from '../models/Dispatch';
import { Schedule } from '../models/Schedule';
import { DispatchFormState, ErrorState } from '../models/FormState';
import { forkJoin, of } from 'rxjs';
import { ScheduleDataService } from '../services/schedule-data.service';
import { ListDataService } from '../services/list-data.service';
import { MoveScheduleDispatchLoads } from '../models/MoveScheduleDispatchLoads';
import { ScheduleItem } from '../models/ScheduleItem';
import { MoveSplitDispatchParameters } from '../models/MoveSplitDispatchParameters';
import { LoadBankApplyParameters } from '../models/LoadBankApplyParameters';
import { LoadBankItem } from '../models/LoadBankItem';
import { DispatchItem } from '../models/DispatchItem';


@Component({
    selector: 'move-split-dispatch-form',
    templateUrl: 'move-split-dispatch-form.component.html',
    styles: [],
    standalone: false
})
export class MoveSplitDispatchFormComponent implements OnInit, OnChanges {
    @ViewChild('closeButton') closeButton;
    @ViewChild('scheduleSearchDropdown') scheduleSearchDropdownRef: ElementRef;
    @Input() moveSplitDispatchFormParams: MoveSplitDispatchParameters;
    @Input() moveSplitFormId: string = 'moveSplitModal';
    @Output() saveComplete = new EventEmitter<number>();
    moveSplitScheduleList: ScheduleItem[] = [];
    loadBankApplyParameters: LoadBankApplyParameters = new LoadBankApplyParameters();
    formStatus: FormStatus = FormStatus.Normal;
    FormStatus = FormStatus;
    scheduleLocationType: string = '';
    schedule: Schedule = new Schedule();
    dispatch: Dispatch = new Dispatch();
    dispatchLocationType: string;
    uomList: ListItem[] = [];
    isMobile: boolean;
    noLoadSelectedError: string = '';
    formState: DispatchFormState;
    selectedMoveSplitSchedule: ScheduleItem;
    totalOriginal: number;
    totalNew: number;
    showAlert = false;
    newDispatchLoads = 0;
    validNewDispatch = new ErrorState();
    showNewDispatchErr = false;
    errorMessage: string = '';
    saveErrorMessage: string = '';
    planPeriod: string;
    oldNewDailyLoad = {
        "originalLoads": [],
        "newLoads": []
    };
    breakoutTotal: number = 0;
    newBreakoutTotal: number = 0;
    loadBankApplyFormId: string = this.moveSplitFormId + 'LoadBankApply';
    globalLocationType: number = 1;
    dispatchItem: DispatchItem = new DispatchItem();
    scheduleItem: ScheduleItem = new ScheduleItem();
    planPeriods: ListItem[] = [];
    showErrorText: string = '';
    searchCustomer: string = '';
    searchName: string = '';
    searchCity: string = '';
    filteredMoveSplitScheduleList: ScheduleItem[] = [];
    showScheduleSearch: boolean = false;
    constructor(private _scheduleDataService: ScheduleDataService, private _listDataService: ListDataService) { }

    //search schedules
    setLocationTypeName() {
        if (this.dispatchItem.locationType == LocationType.Origin) {
            this.scheduleLocationType = 'Destination';
            this.dispatchLocationType = 'Origin';
        }
        else {
            this.scheduleLocationType = 'Origin';
            this.dispatchLocationType = 'Destination';
        }
    }

    getDispatch(): void {
        if (this.moveSplitDispatchFormParams.dispatchId == 0) {
            return;
        }

        this._scheduleDataService.getDispatchItem(this.moveSplitDispatchFormParams.dispatchId).subscribe({
            next: data => {
                this.dispatchItem = data;
                this.setLocationTypeName();
                this.getMoveSplitScheduleList();
            },
            error: err => this.errorMessage = err
        });

    }

    getPlanPeriods(): void {
        if (this.moveSplitDispatchFormParams.locCode.length == 0) {
            return;
        }

        this._listDataService.getPlanPeriods(this.moveSplitDispatchFormParams.locCode).subscribe({
            next: data => {
                this.planPeriods = data;
                if (this.planPeriods.length > 0) {
                    const planPeriodExists = this.planPeriods.some(item => item.value == this.moveSplitDispatchFormParams.planPeriod);
                    if (!planPeriodExists) {
                        this.moveSplitDispatchFormParams.planPeriod = this.planPeriods[0].value;
                    }
                    this.getPeriodDates(true);
                }
            },
            error: err => this.errorMessage = err
        });
    }

    getPeriodDates(refreshData: boolean): void {
        this._listDataService.getPeriodDates(this.moveSplitDispatchFormParams.planPeriod).subscribe({
            next: data => {
                this.moveSplitDispatchFormParams.periodStartDate = data.startDate;
                this.moveSplitDispatchFormParams.periodEndDate = data.endDate;
            },
            error: err => this.errorMessage = err
        });
    }

    planPeriodChange() {
        if (this.moveSplitDispatchFormParams.planPeriod != 'Custom') {
            this.getPeriodDates(false);
        }
    }

    trackPlanPeriod(index: number, item: ListItem) {
        return item.value;
    }

    searchScheduleMoveListItems() {
        this.showErrorText = '';
        this.showScheduleSearch = true;
        this.clearSelectSchedule();
        this.getMoveSplitScheduleList();
    }

    clearSelectSchedule(): void {
        this.searchCustomer = "";
        this.searchName = "";
        this.searchCity = "";
        this.moveSplitScheduleList = [];
    }

    @HostListener('document:click', ['$event'])
    onClick(event: MouseEvent): void {
        const target = event.target as HTMLElement;

        const isScheduleSearchDropdown = this.scheduleSearchDropdownRef?.nativeElement?.contains(target);
        if (!isScheduleSearchDropdown) {
            this.showScheduleSearch = false;
            this.clearSelectSchedule();
            this.showErrorText = "";
        }
    }

    toggleScheduleSearch() {
        if (this.showScheduleSearch) {
            this.showScheduleSearch = false;
            this.clearSelectSchedule();
            this.showErrorText = "";
        }
        else {
            this.showScheduleSearch = true;
            this.getMoveSplitScheduleList();
        }

    }

    getMoveSplitScheduleList() {
        if (this.dispatchItem.locCode.length == 0) {
            return;
        }

        if (this.moveSplitDispatchFormParams.locationType == LocationType.Origin || this.dispatchItem.locationType === LocationType.Destination) {
            this.showErrorText = "This schedule has been created by a different planning perspective! This functionality is not available for this dispatch."
            return;
        }

        let searchParms = this.moveSplitDispatchFormParams.scheduleParameters;
        searchParms.locCode = this.dispatchItem.locCode;
        searchParms.locationType = this.moveSplitDispatchFormParams.locationType;
        searchParms.periodStartDate = this.moveSplitDispatchFormParams.periodStartDate;
        searchParms.periodEndDate = this.moveSplitDispatchFormParams.periodEndDate;
        searchParms.commodityCode = this.dispatchItem.commodityCode;

        this._scheduleDataService.getSchedulesWithFilters(searchParms).subscribe({
            next: data => {
                this.showErrorText = '';
                this.moveSplitScheduleList = data.filter(item => item.scheduleId !== this.dispatchItem.scheduleId);
                if (this.moveSplitScheduleList.length === 0) {
                    this.showErrorText = "There is no other schedule available to perform this functionality. Please search for different plan period.";
                }

                this.filteredMoveSplitScheduleList = [...this.moveSplitScheduleList];
            },
            error: err => this.errorMessage = err
        });
    }

    filterMoveSplitScheduleList() {
        const customer = this.searchCustomer.toLowerCase();
        const name = this.searchName.toLowerCase();
        const city = this.searchCity.toLowerCase();

        this.filteredMoveSplitScheduleList = this.moveSplitScheduleList.filter(item =>
            (!customer || item.customerName?.toLowerCase().includes(customer)) &&
            (!name || item.locationName?.toLowerCase().includes(name)) &&
            (!city || item.locationCity?.toLowerCase().includes(city))
        );
    }


    //move split
    selectMoveSplitSchedule(schedule: ScheduleItem): void {
        this.selectedMoveSplitSchedule = schedule;
        this.saveErrorMessage = '';
        this.showScheduleSearch = false;
    }

    selectUnloadNumber() {
        return false;
    }

    setupNewFormState() {
        this.formStatus = FormStatus.Normal;
        this.formState = new DispatchFormState();
        this.schedule = new Schedule();
        this.dispatch = new Dispatch();
        this.dispatchItem = new DispatchItem();
        this.scheduleItem = new ScheduleItem();
        this.moveSplitScheduleList = [];
        this.filteredMoveSplitScheduleList = [];
        this.selectedMoveSplitSchedule = new ScheduleItem();
        this.noLoadSelectedError = "";
        this.errorMessage = '';
        this.saveErrorMessage = '';
        this.showScheduleSearch = false;
    }

    Save(): void {
        this.saveErrorMessage = '';

        if (this.newDispatchLoads == 0) {
            this.saveErrorMessage = 'Loads count should be more than zero.'
            return;
        }

        if (this.selectedMoveSplitSchedule == null || this.selectedMoveSplitSchedule == undefined || this.selectedMoveSplitSchedule?.scheduleId == 0) {
            this.saveErrorMessage = 'Please select a schedule to move/split the dispatch.'
            return;
        }

        this.noLoadSelectedError = "";
        if (this.dispatch.loadBreakoutList.length !== 0) {
            const elements = this.oldNewDailyLoad["newLoads"]?.filter(x => x.loads != 0).map(x => x.loads);
            const sum = elements.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
            if (!(this.newDispatchLoads == sum)) {
                this.noLoadSelectedError = ' *Please select appropriate break-out loads.'
                return;
            }
        }

        let moveScheduleDispatchLoads = new MoveScheduleDispatchLoads();
        moveScheduleDispatchLoads.destinationLoadCount = this.newDispatchLoads;
        moveScheduleDispatchLoads.destinationScheduleId = this.selectedMoveSplitSchedule.scheduleId;
        moveScheduleDispatchLoads.sourceDispatchLoadCount = this.dispatch.loads;
        moveScheduleDispatchLoads.sourceDispatchId = this.dispatch.dispatchId;
        moveScheduleDispatchLoads.internalComments = this.dispatch.internalNotes;
        moveScheduleDispatchLoads.rate = this.dispatch.rate;
        moveScheduleDispatchLoads.loadNumber = this.dispatch.loadNumber;
        moveScheduleDispatchLoads.unloadNumber = this.dispatch.unloadNumber;
        moveScheduleDispatchLoads.rateUom = this.dispatch.rateUnitOfMeasure;
        if (this.dispatch.loadBreakoutList.length !== 0) {
            moveScheduleDispatchLoads.NewLoads = this.oldNewDailyLoad["newLoads"];
            moveScheduleDispatchLoads.OriginalLoads = this.oldNewDailyLoad["originalLoads"];
        }

        this._scheduleDataService.movescheduledispatchloads(moveScheduleDispatchLoads).subscribe({
            next: data => {
                if (data) {
                    this.showAlert = true;
                    setTimeout(() => {
                        this.showAlert = false;
                        this.saveComplete.emit(this.schedule.scheduleId);
                        const canEmit = this.isScheduleInRange(this.selectedMoveSplitSchedule.scheduleBeginDate, this.selectedMoveSplitSchedule.scheduleEndDate);
                        if (canEmit) {
                            this.saveComplete.emit(this.selectedMoveSplitSchedule.scheduleId);
                        }
                        this.closeButton.nativeElement.click();
                    }, 2000);
                }
            },
            error: err => {
                this.errorMessage = err;
                this.saveErrorMessage = 'Error occurred saving the move/split dispatch.';
            }
        });
    }

    validLoadsInput() {
        if (this.newDispatchLoads < 0) {
            this.validNewDispatch.invalid = true;
            this.validNewDispatch.errorMessage = 'New dispatch load can\'t be negative.';
            this.newDispatchLoads = this.dispatch.loads;
            setTimeout(() => {
                this.validNewDispatch.invalid = false;
                this.validNewDispatch.errorMessage = '';
            }, 2000);
        }
        else if (this.newDispatchLoads > this.dispatch.loads) {
            this.validNewDispatch.invalid = true;
            this.validNewDispatch.errorMessage = 'New dispatch can\'t be greater than old dispatch load.';
            this.newDispatchLoads = this.dispatch.loads;
            setTimeout(() => {
                this.validNewDispatch.invalid = false;
                this.validNewDispatch.errorMessage = '';
            }, 2000);
        }
        else {
            this.validNewDispatch.invalid = false;
            this.validNewDispatch.errorMessage = '';
        }
    }

    resetDailyLoadsData() {
        this.totalNew = 0;
        this.totalOriginal = 0;
        this.oldNewDailyLoad.originalLoads = [];
        this.oldNewDailyLoad.newLoads = [];
        this.oldNewDailyLoad.originalLoads = JSON.parse(JSON.stringify(this.dispatch.loadBreakoutList));
        this.oldNewDailyLoad.newLoads = this.dispatch.loadBreakoutList.map(obj => ({
            ...obj,
            loads: 0
        }));
        this.updateTotals();
    }

    moveToNew(index: number) {
        if (this.oldNewDailyLoad.originalLoads[index].loads > 0) {
            this.oldNewDailyLoad.originalLoads[index].loads--;
            this.oldNewDailyLoad.newLoads[index].loads++;
            this.updateTotals();
        }
    }

    moveToOriginal(index: number) {
        if (this.oldNewDailyLoad.newLoads[index].loads > 0) {
            this.oldNewDailyLoad.newLoads[index].loads--;
            this.oldNewDailyLoad.originalLoads[index].loads++;
            this.updateTotals();
        }
    }

    updateTotals() {
        this.totalOriginal = this.oldNewDailyLoad.originalLoads.reduce((sum, item) => sum + (item.loads || 0), 0);
        this.totalNew = this.oldNewDailyLoad.newLoads.reduce((sum, item) => sum + (item.loads || 0), 0);

        if (this.totalNew > this.newDispatchLoads) {
            this.noLoadSelectedError = '*Please select appropriate break-out loads.';
        } else {
            this.noLoadSelectedError = '';
        }
    }

    //load bank
    setLoadBankParametersFromSchedule(parameters: LoadBankApplyParameters) {
        parameters.locationId = this.schedule.location.locationId;
        parameters.locationName = this.schedule.location.locationName;
        parameters.customerId = this.schedule.customer.customerId;
        parameters.customerName = this.schedule.customer.customerName;
        this.schedule.contracts.forEach((contract) => {
            if (!parameters.contractIds.includes(contract.contractId)) {
                parameters.contractIds.push(contract.contractId);
                parameters.contractNumber += contract.contractNumber + ' ';
            }
        });
    }

    setLoadBankParametersFromDispatch(parameters: LoadBankApplyParameters) {
        parameters.locationId = this.dispatch.location.locationId;
        parameters.locationName = this.dispatch.location.locationName;
        parameters.customerId = this.dispatch.customer.customerId;
        parameters.customerName = this.dispatch.customer.customerName;
        if (this.dispatch.contract.contractId > 0) {
            parameters.contractIds.push(this.dispatch.contract.contractId);
            parameters.contractNumber = this.dispatch.contract.contractNumber;
        }
    }


    openLoadBank(loadBankType: LoadBankType) {
        let parameters = new LoadBankApplyParameters();
        parameters.parentModal = this.moveSplitFormId;
        parameters.locCode = this.schedule.locCode;
        parameters.loadBankType = loadBankType;
        parameters.commodityCode = this.schedule.commodityCode;
        if (loadBankType == LoadBankType.Load) {
            if (this.schedule.locationType == LocationType.Origin) {
                this.setLoadBankParametersFromSchedule(parameters);
            }
            else {
                this.setLoadBankParametersFromDispatch(parameters);
            }
        }
        else {
            if (this.schedule.locationType == LocationType.Destination) {
                this.setLoadBankParametersFromSchedule(parameters);
            }
            else {
                this.setLoadBankParametersFromDispatch(parameters);
            }
        }
        this.loadBankApplyParameters = parameters;
        return false;
    }

    applyLoadNumber(loadBankItem: LoadBankItem) {
        if (loadBankItem.loadBankType == LoadBankType.Load) {
            this.dispatch.loadNumber = loadBankItem.loadNumber;
            this.dispatch.loadNumberId = loadBankItem.loadBankId;
        }
        else {
            this.dispatch.unloadNumber = loadBankItem.loadNumber;
            this.dispatch.unloadNumberId = loadBankItem.loadBankId;
        }
    }

    isScheduleInRange(scheduleBeginDateString: string, scheduleEndDateString: string): boolean {
        const scheduleBeginDate = new Date(scheduleBeginDateString);
        const scheduleEndDate = new Date(scheduleEndDateString);
        const filterBeginDate = new Date(this.convertDateString(this.moveSplitDispatchFormParams.periodStartDate));
        const filterEndDate =  new Date(this.convertDateString(this.moveSplitDispatchFormParams.periodEndDate));
        return scheduleBeginDate >= filterBeginDate && scheduleBeginDate <= filterEndDate && scheduleEndDate >= filterBeginDate && scheduleEndDate <= filterEndDate;
    }

    convertDateString(dateInput: string): string {
        const [year, month, day] = dateInput.split('-');
        return `${month}/${day}/${year}`;
    }

    //initlizers, changers
    ngOnInit(): void {
        if (window.innerWidth <= MOBILE_BREAKPOINT) {
            this.isMobile = true;
        }

        this._listDataService.getListItems("unitofmeasure").subscribe({
            next: data => {
                this.uomList = data;
            },
            error: err => this.errorMessage = err
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        // 1-destroyPlatform0-origin
        this.globalLocationType = this.moveSplitDispatchFormParams?.scheduleParameters?.locationType;
        if (changes['moveSplitDispatchFormParams']) {
            this.setupNewFormState();
            this.getPlanPeriods();
            this.getDispatch();
           
            this.planPeriod = this.moveSplitDispatchFormParams.planPeriod;
            if (this.moveSplitDispatchFormParams.scheduleParameters) {
                this.planPeriodChange();
            }

            const schedule$ = this.moveSplitDispatchFormParams.scheduleId > 0 ? this._scheduleDataService.getSchedule(this.moveSplitDispatchFormParams.scheduleId) : of(null);
            const dispatch$ = this.moveSplitDispatchFormParams.dispatchId > 0 ? this._scheduleDataService.getDispatch(this.moveSplitDispatchFormParams.dispatchId) : of(null);
            forkJoin({
                schedule: schedule$,
                dispatch: dispatch$
            }).subscribe({
                next: ({ schedule, dispatch }) => {
                    if (schedule) {
                        this.getMoveSplitScheduleList();
                    }
                    else {
                        if (dispatch?.scheduleId > 0) {
                            this._scheduleDataService.getSchedule(dispatch.scheduleId).subscribe((schedule) => {
                                this.schedule = schedule;
                                this.getMoveSplitScheduleList();
                            });
                        }
                    }
                    this.schedule = schedule ?? new Schedule();
                    this.dispatch = dispatch ?? new Dispatch();
                    if (this.dispatch) {
                        this.newDispatchLoads = this.dispatch.loads;
                        this.resetDailyLoadsData();
                    }

                },
                error: err => this.errorMessage = err
            });
        }

        if (changes['moveSplitFormId']) {
            this.loadBankApplyFormId = this.moveSplitFormId + 'LoadBankApply';
        }
    }
}

